import PropTypes from 'prop-types'

const StatCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  iconBgColor = 'bg-primary-100 dark:bg-primary-900',
  iconColor = 'text-primary-600 dark:text-primary-400',
  trend,
  trendValue,
  trendColor = 'text-success-600 dark:text-success-400',
  className = '',
}) => {
  return (
    <div
      className={`bg-surface-light dark:bg-surface-dark rounded-xl shadow-md dark:shadow-md p-6 ${className}`}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-neutral-900 dark:text-white">{title}</h3>
        {Icon && (
          <div className={`w-10 h-10 ${iconBgColor} rounded-lg flex items-center justify-center`}>
            <Icon className={`${iconColor} text-xl`} />
          </div>
        )}
      </div>

      <div className="flex items-end justify-between">
        <div>
          <p className="text-3xl font-bold text-neutral-900 dark:text-white mb-2">{value}</p>
          {subtitle && <p className="text-sm text-neutral-600 dark:text-neutral-400">{subtitle}</p>}
        </div>

        {trend && trendValue && (
          <div className="text-right">
            <div className={`flex items-center space-x-1 ${trendColor}`}>
              <span className="text-sm font-medium">
                {trend === 'up' ? '+' : ''}
                {trendValue}
              </span>
              <svg
                className={`w-4 h-4 ${trend === 'up' ? 'rotate-0' : 'rotate-180'}`}
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">from last month</p>
          </div>
        )}
      </div>
    </div>
  )
}

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.elementType,
  iconBgColor: PropTypes.string,
  iconColor: PropTypes.string,
  trend: PropTypes.oneOf(['up', 'down']),
  trendValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  trendColor: PropTypes.string,
  className: PropTypes.string,
}

export default StatCard
